var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "m10 2.089 2.237 4.102.228.417.466.087 4.593.86-3.21 3.396-.326.345.06.47.602 4.635-4.221-2.004-.429-.204-.429.204L5.35 16.4l.601-4.634.061-.471-.326-.345-3.21-3.396 4.593-.86.466-.087.228-.417z"
  })));
};
export default SvgStar;